import { DatePipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';

import { PendingCommissionTask } from '../../pending-referral-tasks.definitions';
import { PendingTaskCardComponent } from './pending-task-card.component';

@Component({
  standalone: true,
  imports: [DatePipe, PendingTaskCardComponent],
  selector: 'lib-pending-commission-task-card',
  host: {
    class: 'block h-full',
  },
  template: `
    <lib-pending-task-card
      [route]="['/commissions', task().commission.commission_id]"
    >
      <div class="min-w-0">
        <div class="flex flex-wrap items-center gap-1.5">
          <span class="text-sm font-semibold text-gray-900">
            {{ task().commission.referral_code }}
          </span>
          <span
            class="rounded-full bg-indigo-100 px-2 py-0.5 text-xs font-medium text-indigo-800"
          >
            Due for invoice
          </span>
        </div>
        <div class="mt-1 truncate text-sm text-gray-700">
          Payee: {{ task().commission.payee_name || '-' }}
        </div>
        <div class="mt-1 flex justify-between gap-2 text-xs text-gray-500">
          <span class="truncate">
            {{ formattedAmount() }}
          </span>
          <span class="shrink-0">
            Due on:
            {{
              task().commission.invoice_eligible_at | date : 'dd-MMM-yyyy'
            }}
          </span>
        </div>
      </div>
    </lib-pending-task-card>
  `,
})
export class PendingCommissionTaskCardComponent {
  task = input.required<PendingCommissionTask>();

  protected readonly formattedAmount = computed(() => {
    const { amount_minor: amountMinor, currency = 'KES' } =
      this.task().commission;

    if (amountMinor === undefined || amountMinor === null) return '-';

    return new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency,
      maximumFractionDigits: 2,
    }).format(amountMinor / 100);
  });
}
